module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.a1a0ed86.eot";